<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      志愿详情
    </div>
    <div class="padding-sm flex align-center justify-around">
      <div class="volunteer-detail">
        <div class="student-info border-bottom flex align-center justify-between">
          <div>
            <span class="name">张坤</span>
            <span class="sex">男</span>
            <span class="age">19</span>
          </div>
          <div class="class">2020级1班</div>
        </div>

        <div class="student border-bottom">
          <p>学习课程:</p>
          <div>
            《课程课程课程》  《课程课程课程》  《课程课程课程》  《课程课程课程》   《课程课程课程》  《课程课程课程》
          </div>
        </div>

        <div class="exam border-bottom">
          <p class="flex align-center justify-between">
            <span>考试情况:</span>
            <span>考勤率：74%</span>
          </p>
        </div>

        <div class="exam-num border-bottom">
          <p class="flex align-center justify-between">
            <span>期中考试成绩:</span>
            <span>课程：67分  <i class="padding-left"></i> 课程：67分 <i class="padding-left"></i>       课程：67分 <i class="padding-left"></i>       课程：67分</span>
          </p>
        </div>

        <div class="theac border-bottom">
          <p class="desc">老师评语:</p>
          <div>
            张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。
          </div>
          <p>
            老师姓名：王艳<br/>
            日期：2020年12月20日
          </p>
        </div>

        <div class="flex align-center margin-tb-sm">
          <el-button class="padding-lr-xl submit-btn" type="primary" >录用</el-button>
          <el-button class="padding-lr-xl submit-btn" >拒绝</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "volunteerDetail",
  data() {
    return {

    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/practiceBase/practiceBaseList',
        "当前位置：岗位管理 - 实习岗位管理 - 志愿管理 - 志愿详情",
        true
    );
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.volunteer-detail{
  width: 80%;
  .border-bottom{
    padding: 20px 0;
    border-bottom: 1px solid #eee;
  }
  .name{
    font-size: 28px;
    line-height: 42px;
    color: #009688;
  }
  .sex{
    font-size: 20px;
    margin-left: 30px;
  }
  .age{
    font-size: 20px;
    margin-left: 30px;
  }
  .class{
    font-size: 20px;
  }
  .student{
    p{
      font-size: 18px;
      line-height: 42px;
      color: #006fd6;
    }
    div{
      font-size: 16px;
     line-height: 32px;
    }
  }
  .exam{
    font-size: 18px;
    line-height: 42px;
    color: #00c662;
  }
  .exam-num{
    font-size: 18px;
    line-height: 42px;
    color: #ef5a00;
  }
  .theac{
    font-size: 18px;
    line-height: 42px;
    p{
      text-align: right;
      &.desc{
        text-align: left;
        color: #006fd6;
      }
    }
    div{
      text-indent: 36px;
    }
  }
}
</style>